// @flow

import React, { type Node } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { SaveAttachmentButton } from '@tectonics/look-and-feel/uber/commons/molecules';

export function CashSavePDFButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const href = `${getGatewayVoucherUrl(incomingPayment)}&format=pdf`;
  const country = getCountry(incomingPayment);


  switch (country) {
    case 'ar':
      return(
        <SaveAttachmentButton href={href}>
          Guardar Instrucciones en PDF
        </SaveAttachmentButton>
      );

    case 'mx':
      return(
        <SaveAttachmentButton href={href}>
          Guardar Boleta en PDF
        </SaveAttachmentButton>
      );

    case 'bo':
      return(
        <SaveAttachmentButton href={href} outline>
          Guardar Instrucciones en PDF
        </SaveAttachmentButton>
      );

    default:
      throw new Error(`Save as PDF Button: button not found for country ${country}`);

  }
}
